import { Flex } from "@chakra-ui/layout"
import React from "react"
import ReactPlayer from "react-player"
import "react-responsive-carousel/lib/styles/carousel.min.css" // requires a loader
import { Carousel } from "react-responsive-carousel"
import styled from "styled-components"
import { useMediaQuery } from "@chakra-ui/media-query"

const YoutubeSlide = ({ url, isSelected }) => (
    <div style={{ paddingTop: "56.25%", position: "relative", width: "100%" }}>
        <ReactPlayer
            className="react-player"
            width="100%"
            height="100%"
            url={url}
            //  playing={isSelected}
            style={{
                position: "absolute",
                top: "0",
                left: "0",
            }}
        />
    </div>
)
const videoUrl = [
    "yKdxrvzNtLM",
    "DyPgmLwkLG0",
    "T4uyBDgutuo",
    "1y0DzxakTFg",
    "FlFUJNox1VI",
    "TSJBnJLxq5I",
    "rwQgVVjmuFw",
    "xVSZ0R1v6Jk",
    "6KySwqTTdTc",
    "G-NA1dEz7bM",
]

const ShowThumbs = () => {
    const [hideThumbs] = useMediaQuery("(min-width: 550px)")
    return hideThumbs
}

const CaruselThumbnails = () => {
    const customRenderItem = (item, props) => <item.type {...item.props} {...props} />

    const getVideoThumb = (videoId) => `https://img.youtube.com/vi/${videoId}/default.jpg`

    const getVideoId = (url) => url.substr("https://www.youtube.com/embed/".length, url.length)

    const customRenderThumb = (children) =>
        children.map((item, i) => {
            const videoId = getVideoId(item.props.url)
            return <img key={i} src={getVideoThumb(videoId)} alt="" />
        })

    return (
        <Flex
            w="100%"
            pt={["50px", "50px", "50px", "110px"]}
            pb="30px"
            align="center"
            justify="center"
            textAlign="center"
            px={["10px", "30px"]}
        >
            <Wrapper>
                {ShowThumbs()}
                <Carousel
                    renderItem={customRenderItem}
                    renderThumbs={customRenderThumb}
                    autoPlay={false}
                    width="100%"
                    showArrows={true}
                    showStatus={true}
                    dynamicHeight={false}
                    showIndicators={!ShowThumbs()}
                    showThumbs={ShowThumbs()}
                >
                    {videoUrl.map((video, i) => {
                        return (
                            <YoutubeSlide key={i} url={`https://www.youtube.com/embed/${video}`} />
                        )
                    })}
                </Carousel>
            </Wrapper>
        </Flex>
    )
}

const Wrapper = styled.div`
    width: 100%;
    max-width: 900px;

    .carousel .control-dots {
        bottom: -12px;
    }

    .carousel .control-prev.control-arrow:before {
        border-right-color: black;
    }
    .carousel .control-next.control-arrow::before {
        border-left-color: black;
    }
`

export default CaruselThumbnails

//temp images
// const videos = ["../mob-image1.png", "../mob-image2.png", "../mob-image3.png"]

// return (
// <Flex
//     w="100%"
//     pt={["50px", "50px", "50px", "110px"]}
//     pb="30px"
//     align="center"
//     justify="center"
//     textAlign="center"
//     px="30px"
// >
//     {ShowThumbs()}
//     <Carousel autoPlay thumbWidth="70px" showThumbs={ShowThumbs()}>
//         {videos.map((video, i) => {
//             return (
//                 <Wrapper key={i}>
//                     <img
//                         objectFit="cover"
//                         style={{ maxWidth: "800px", height: "100%" }}
//                         objectPosition="top"
//                         src={video}
//                     />
//                 </Wrapper>
//             )
//         })}
//     </Carousel>
// </Flex>
// )
